<template>
  <gg-card class="fill-height">
    <v-skeleton-loader :loading="loading" type="article">
      <gg-card-header>
        Payment Method
        <gg-btn primary class="float-right" @click="triggerModal">
          Edit
        </gg-btn>
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <div>
              <p>
                Current Payment Method: <b>{{ paymentMethod }} {{ paymentEmail }}</b>
              </p>
            </div>
            <div>
              <p>
                <router-link :to="{ name: 'affiliates_payments' }">
                  View Payment History
                </router-link>
              </p>
            </div>
          </v-col>
        </v-row>
      </gg-card-text>
    </v-skeleton-loader>

    <gg-modal v-if="modal" :is-active="modal" @close="triggerModal">
      <template v-slot:toolbar>Change PayPal Address</template>
      <template v-slot:body>
        <gg-text-field label="Enter your PayPal address. This change will take place immediately. "
                       v-model="email"
                       name="Email"
                       v-validate="'required|email'"
                       :error-messages="errors.collect('Email')"
        />
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="triggerModal">Cancel</gg-btn>
        <gg-btn primary :loading="pending" @click="changeEmail">Save</gg-btn>
      </template>
    </gg-modal>

  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PaymentMethod',
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    pending: false,
    modal: false,
    email: ''
  }),
  computed: {
    ...mapGetters({
      profile: 'affiliates/profile',
    }),
    paymentMethod () {
      if (!this.profile) {
        return
      }
      switch (this.profile.payment_method) {
        case 'paypal':
          return 'PayPal'
        default:
          return 'PayPal'
      }
    },
    paymentEmail () {
      if (!this.profile) {
        return ''
      }
      return this.profile.paypal_address !== '' ? `(${this.profile.paypal_address})` : ''
    }
  },
  methods: {
    ...mapActions({
      setPaypalAddress: 'affiliates/setPaypalAddress',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    triggerModal () {
      this.modal = !this.modal
    },
    async changeEmail () {
      try {
        const valid = await this.$validator.validateAll()

        if (!valid) {
          return
        }

        this.pending = true
        const msg = await this.setPaypalAddress(this.email)
        this.triggerModal()
        this.email = ''
        this.reportSuccess(msg)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  }
}
</script>

<style scoped>

</style>
